import { Language } from '@models';

const generateType = (actionType = 'CUSTOM', reducer = 'UNIVERSAL/APP') => `${reducer}/${actionType}`;

export const setTheme = (theme = '') => {
	return async (dispatch, getState) => {
		const themes = ['dark', 'light'];
		if (!theme || !themes.includes(theme)) return console.log(`${theme} theme name invalid`);

		localStorage.setItem('_theme', theme);
		document.querySelector('body').setAttribute('_theme', theme);

		await dispatch({
			type: generateType('CUSTOM'),
			payload: { ...getState().universal.app, theme },
		});
	};
};

export const setLanguage = (language = '') => {
	return async (dispatch, getState) => {
		if (!language || !Language.supported[language]) return console.log(`${language} language name invalid`);

		localStorage.setItem('_language', language);
		document.querySelector('body').setAttribute('_language', language);

		await dispatch({
			type: generateType('CUSTOM'),
			payload: { ...getState().universal.app, language },
		});
	};
};
